import {
  GET_ALL_PROJECTS,
  SET_LOADING,
  IS_INCLUDE_ARCHIVED,
  IS_MY_PROJECTS,
  SET_PROJECT_DATA,
  SET_PROJECT_DETAILS,
  SET_PROJECT_DETAILS_LOADING,
  RESET_PROJECT_DATA,
  RESET_PROJECT_METRIC_DATA,
  SET_TAB_CONTENT,
  SET_PROJECT_SEARCH_TEXT,
  SET_PROJECT_LOADING,
  SET_CUSTOM_COLUMNS_LIST,
  SET_PROJECT_SEARCH_TYPE,
  SET_REPURPOSE_PACKAGING_ASSETS_LOADING,
  SET_WORKFLOW_ITEMS,
  SET_PROJECT_METRIC_DATA,
} from './actionTypes'
import apiConfig from '../../apiConfig'
import * as projectApi from '../../services/projectService'

const { isPol = false } = apiConfig

function getAllProjects(data, total_count, total_pages) {
  return {
    type: GET_ALL_PROJECTS,
    payload: {
      data,
      total_count,
      total_pages,
    },
  }
}
export const setSearchType = (searchType = '') => {
  return {
    type: SET_PROJECT_SEARCH_TYPE,
    payload: searchType,
  }
}
export const getAllProjectsAPI = (
  lanId = '',
  company = '',
  page = 0,
  rowsPerPage = 50,
  searchQuery = '',
  searchTerm = 'PROJECT_NAME',
  orderBy = 'created_date',
  order = 'desc',
  isMyProjects = false,
  options = {}
) => {
  return async (dispatch, getState) => {
    dispatch(setLoading(true))

    const { signal } = options
    const isAborted = () => signal?.aborted

    try {
      const {
        dashboardReducer: { isIncludedArchived = false, searchQuery = '' } = {},
        authReducer: { lanId: userId = '' } = {},
      } = getState()

      const response = await projectApi.getAllProjectService({
        page,
        rowsPerPage,
        isMyProjects,
        isIncludedArchived,
        searchTerm,
        searchQuery,
        company,
        userId,
        lanId,
        orderBy,
        order,
      })

      if (isAborted()) return

      const result = response?.data?.project_dashboard_response?.map((rObj) => {
        const { first_name, last_name } = rObj?.created_by || {}
        return {
          ...rObj,
          user_name: [first_name, last_name].filter(Boolean).join(' '),
        }
      })

      dispatch(
        getAllProjects(
          result,
          response?.data?.total_count,
          response?.data?.pages_count
        )
      )

      const projectIds = (result || [])
        .map((project) => project?.project_id)
        .filter(Boolean)

      if (!projectIds.length) {
        dispatch(setProjectDetailsLoading(false))
        return
      }

      dispatch(setProjectDetailsLoading(true))

      const chunkSize = 5
      const chunks = []
      for (let i = 0; i < projectIds.length; i += chunkSize) {
        chunks.push(projectIds.slice(i, i + chunkSize))
      }

      const projectDetails = {}

      for (const chunk of chunks) {
        if (isAborted()) break

        const responses = await Promise.allSettled(
          chunk.map((projectId) =>
            projectApi
              .getProjectStatus({ projectId })
              .then((res = {}) => ({ projectId, data: res?.data || {} }))
          )
        )

        if (isAborted()) break

        responses
          .filter((r) => r.status === 'fulfilled')
          .map((r) => r.value)
          .forEach(({ projectId, data }) => {
            if (projectId) projectDetails[projectId] = data
          })
      }

      if (!isAborted() && Object.keys(projectDetails).length) {
        dispatch(setProjectDetails(projectDetails))
      }
    } catch (error) {
      if (error?.name !== 'CanceledError' && error?.name !== 'AbortError') {
        // optional: log real errors
        console.log(error)
      }
    } finally {
      if (!signal?.aborted) {
        dispatch(setProjectDetailsLoading(false))
        dispatch(setLoading(false))
      }
    }
  }
}

export const setProjectsToArchive = (ids) => {
  return async (dispatch, getState) => {
    const body = {
      project_ids: ids,
    }
    projectApi
      .setProjectArchiveService({
        body,
      })
      .then((response) => {
        dispatch(getAllProjectsAPI())
      })
      .catch((error) => {
        //console.log(error)
      })
  }
}

export const getProjectInfo = ({
  page = 0,
  numberOfRows,
  projectId = '',
  accessToken = '',
  lanId = '',
  searchText = '',
  searchBy = '',
  callWorkflow = false,
  company = '',
}) => {
  return async (dispatch, getState) => {
    dispatch(setProjectLoading(true))
    projectApi
      .fetchProjectImages({
        page,
        numberOfRows,
        projectId,
        searchText,
        searchBy,
      })
      .then((res = {}) => {
        const { data = {} } = res
        const fetchProjectStatusData = () => {
          return projectApi
            .getProjectStatus({ projectId })
            .then((statusRes = {}) => {
              const { data: statusData = {} } = statusRes
              if (statusData) {
                dispatch(setProjectMetricInfo(statusData))
              }
            })
            .catch((error) => {
              console.log(error)
            })
        }

        const fetchProjectTcinStatusData = () => {
          return projectApi
            .getProjectTCINStatus({ page, numberOfRows, projectId })
            .then((workflowRes = {}) => {
              dispatch(setWorkflowItems(projectId, workflowRes?.data || {}))
            })
            .catch((error) => {
              console.log(error)
            })
        }

        if (callWorkflow) {
          dispatch(setProjectInfo(data))
        }

        const tcins = Array.from(
          new Set(
            (data?.tcin_info || [])
              .map((item) => item?.tcin)
              .filter((tcin) => tcin)
          )
        )

        if (tcins.length && callWorkflow) {
          Promise.allSettled([
            fetchProjectStatusData(),
            fetchProjectTcinStatusData(),
          ])
        }
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        dispatch(setProjectLoading(false))
      })
  }
}
export const callRepurposeAHImages = ({
  assetList = {},
  lanId = '',
  callBack = () => {},
}) => {
  return async (dispatch, getState) => {
    setRepurposeLoading(true)
    projectApi
      .repurposeAHImages({
        params: { repurpose_files: assetList },
        lanId,
      })
      .then((res = {}) => {
        const { data = {} } = res
        callBack(data)
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        setRepurposeLoading(false)
      })
  }
}
export const getProjectPackagingInfo = ({
  page = 0,
  numberOfRows,
  projectId = '',
  searchText = [],
  searchBy = '',
  currentProjectData,
}) => {
  return async (dispatch, getState) => {
    const projectExistingData = { ...currentProjectData }
    dispatch(setProjectLoading(true))
    projectApi
      .fetchProjectPackagingImages({
        page,
        numberOfRows,
        projectId,
        searchText,
        searchBy,
      })
      .then((res = {}) => {
        const { data = {} } = res
        const finalData =
          data?.project_id === projectExistingData?.project_id
            ? { ...projectExistingData, ...data }
            : data
        dispatch(setProjectInfo(finalData))
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        dispatch(setProjectLoading(false))
      })
  }
}

export const getAdditionalAssetsInfo = ({
  page = 0,
  numberOfRows,
  projectId = '',
  searchText = [],
  searchBy = '',
  currentProjectData = {},
}) => {
  return async (dispatch, getState) => {
    const projectExistingData = { ...currentProjectData }
    dispatch(setProjectLoading(true))
    projectApi
      .fetchAdditionalAssets({
        page,
        numberOfRows,
        projectId,
        searchText,
        searchBy,
      })
      .then((res = {}) => {
        const { data = {} } = res
        const finalData =
          data?.project_id === projectExistingData?.project_id
            ? { ...projectExistingData, ...data }
            : data
        dispatch(setProjectInfo(finalData))
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        dispatch(setProjectLoading(false))
      })
  }
}

export const getCustomColumnsList = ({ userId = '' }) => {
  return async (dispatch, getState) => {
    dispatch(setProjectLoading(true))
    projectApi
      .fetchCustomColumnsList({ userId })
      .then((res = {}) => {
        const { data: { column_list = [] } = {} } = res
        dispatch(setCustomColumns(column_list))
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        dispatch(setProjectLoading(false))
      })
  }
}

export const updateCustomColumnsList = ({ userId = '', columnList = [] }) => {
  return async (dispatch, getState) => {
    dispatch(setProjectLoading(true))
    projectApi
      .updateCustomColumnsList({ userId, columnList })
      .then((res = {}) => {
        const { data: { project_columns: { column_list = [] } = {} } = {} } =
          res
        dispatch(setCustomColumns(column_list))
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        dispatch(setProjectLoading(false))
      })
  }
}

export const archiveProjects = ({ params = {}, callBack = () => {} }) => {
  return async (dispatch, getState) => {
    dispatch(setProjectLoading(true))
    projectApi
      .makeProjectsArchive({ params })
      .then((res = {}) => {
        callBack()
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        dispatch(setProjectLoading(false))
      })
  }
}

export const removeTcinsFromProjectAction = ({
  data = {},
  projectId = '',
  lanId = '',
  successCallBack = () => {},
}) => {
  return async (dispatch, getState) => {
    dispatch(setProjectLoading(true))
    projectApi
      .removeTcinsFromProjectService({ data, projectId, lanId })
      .then((res = {}) => {
        successCallBack()
      })
      .catch((error) => {
        console.log(error)
      })
  }
}

export const updateProjectAction = ({
  projectId = '',
  requestBody = {},
  accessToken = '',
  lanId = '',
  successCallBack = () => {},
  errorCallBack = () => {},
  projectData = {},
}) => {
  return async (dispatch, getState) => {
    dispatch(setProjectLoading(true))
    projectApi
      .updateProjectService({
        projectId,
        requestBody,
        accessToken,
        lanId,
      })
      .then((res = {}) => {
        const { data = {} } = res
        data.tcin_info = projectData?.tcin_info || []
        data.tcin_pagination_details =
          projectData?.tcin_pagination_details || []
        const finalData =
          data?.project_id === projectData?.project_id
            ? { ...projectData, ...data }
            : data
        dispatch(setProjectInfo(finalData))
        successCallBack()
      })
      .catch((error) => {
        errorCallBack(error)
      })
      .finally(() => {
        dispatch(setProjectLoading(false))
      })
  }
}

export const setIsMyProjects = (isMyProj) => {
  return {
    type: IS_MY_PROJECTS,
    payload: isMyProj,
  }
}

export const setIsIncludeArchived = (isIncArch) => {
  return {
    type: IS_INCLUDE_ARCHIVED,
    payload: isIncArch,
  }
}

const setLoading = (loading) => {
  return {
    type: SET_LOADING,
    payload: loading,
  }
}

export const setProjectLoading = (loading) => {
  return {
    type: SET_PROJECT_LOADING,
    payload: loading,
  }
}

export const setRepurposeLoading = (loading) => {
  return {
    type: SET_REPURPOSE_PACKAGING_ASSETS_LOADING,
    payload: loading,
  }
}

export const setProjectInfo = (data) => {
  return {
    type: SET_PROJECT_DATA,
    payload: data,
  }
}
export const setProjectMetricInfo = (data) => {
  return {
    type: SET_PROJECT_METRIC_DATA,
    payload: data,
  }
}
export const setWorkflowItems = (projectId, data) => {
  return {
    type: SET_WORKFLOW_ITEMS,
    payload: {
      projectId,
      data,
    },
  }
}
export const setProjectDetails = (data) => {
  return {
    type: SET_PROJECT_DETAILS,
    payload: data,
  }
}

export const setProjectDetailsLoading = (loading) => {
  return {
    type: SET_PROJECT_DETAILS_LOADING,
    payload: loading,
  }
}
export const resetProjectInfo = () => {
  return {
    type: RESET_PROJECT_DATA,
  }
}

export const resetProjectMetricInfo = () => {
  return {
    type: RESET_PROJECT_METRIC_DATA,
  }
}

export const setCustomColumns = (data) => {
  return {
    type: SET_CUSTOM_COLUMNS_LIST,
    payload: data,
  }
}

export const setProjectSearchText = (query) => {
  return {
    type: SET_PROJECT_SEARCH_TEXT,
    payload: query,
  }
}

export const setTabContentInfo = (data) => {
  return {
    type: SET_TAB_CONTENT,
    payload: data,
  }
}
